import React, { useEffect, useState } from "react";
import { useNavigate, NavLink, useParams } from "react-router-dom";
import API  from "../../services";
import "./EventsPage.scss"
import { FavoriteBorderOutlined, FavoriteOutlined } from "@mui/icons-material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { toast } from "react-toastify";
import store from "../../store/store";
import { Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";
import { useTranslation } from "../../hooks/useTranslation";

const EventsPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { gameInfo } = useParams();
    const [gameId, gameName, lobby] = atob(gameInfo || "").split("#");
    const [loading, setLoading] = useState<boolean>(false);
    const [eventsData, setEventsData] = useState<any>();
    // const lobby = store.getState().userDetails.lobby;
    const getEvents = async () => {
        setLoading(true);
        let response;
        try {
            response = await API.post(`/webapp/get-events-by-sport`, {
                id: gameId,
                lobby: lobby
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
            return;
        }

        if (response.data.status !== "RS_OK") {
            navigate("/sports");
        }

        if (response && response.data.sections) {
            const hasEvents = response.data.sections.some((section: any) => section.items?.length > 0);
            if (!hasEvents) {
                navigate("/sports")
                toast.error(t("sports.messages.noEventsFound"));
                return
            }
            setEventsData(response.data?.sections);
        }

        setLoading(false);
    };

    const handleFavoriteClick = async (game: any) => {
        setEventsData((prevGameData: any) =>
            prevGameData?.map((section: any) => ({
                ...section,
                items: section?.items?.map((gameMap: any) =>
                    gameMap?.id === game?.id
                        ? { ...gameMap, isFavorite: !gameMap?.isFavorite }
                        : gameMap
                ),
            }))
        );
        let response;
        try {
            // Make the API call to update the favorite status
            response = await API.post('/webapp/set-favorite', {
                category: game.category,
                id: game.id,
                isFavorite: !game.isFavorite,
                name: game?.name,
                provider: game?.provider,
                subProvider: game.subProvider,
                thumbnail: game.thumbnail,
                type: game.type,
                tgProviderId: game?.tgProviderId,
                tableId: game?.tableId,
                userKey: sessionStorage.getItem("userKey")
            });

        } catch (error) {
            console.error('Error updating favorite status:', error);
            // Revert the state change if the API call fails
        }

        if (response && response.data?.status === "RS_OK") {
            const updatedGameData = eventsData?.map((section: any) => ({
                ...section,
                items: section?.items?.map((gameMap: any) =>
                    gameMap?.id === game?.id
                        ? { ...gameMap, isFavorite: !gameMap?.isFavorite }
                        : gameMap
                ),
            }));
            setEventsData(updatedGameData);
        }
    };

    useEffect(() => {
        getEvents();
    }, []);

    return (
        <div className="flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] events-ctn">
            {
                loading ? (
                    <div className="home-loading">
                        <img src={Loader(domain)} style={{ height: '10rem' }} />
                    </div>
                ) : (
                    <>
                        <div className="flex items-center justify-between px-4 mt-2 w-full pb-4 sticky top-0 z-10 provinfo">
                            <div className="flex items-center">
                                <div>
                                    <div className="bg-inputbox-color flex p-1 mr-[1rem] rounded"
                                        onClick={() => navigate(-1)}
                                    >
                                        <ArrowBackIcon
                                            className="text-border-color aspect-square w-[18px]"
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                    </div>
                                </div>
                                <div className="">{gameName}</div>
                            </div>

                        </div>
                        <div className="main-section">
                            {eventsData?.map((section: any, index: number) => (
                                section?.items?.length > 0 && (
                                    <div key={index}>
                                        <div style={{ display: 'flex', alignItems: 'center', padding: '0 0 0.75rem 0.75rem' }}>
                                            <div>
                                                <img src={section?.sectionIcon} alt={section?.sectionTitle} style={{ width: '1rem', marginRight: '5px' }} />
                                            </div>
                                            <span className="section-title">{section.sectionTitle}</span>
                                        </div>

                                        <div className="grid-cols-2 grid gap-2 px-3 w-full pb-[2rem] sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 provinfo">
                                            {section?.items.map((game: any, gameIndex: number) => (
                                                <div>
                                                    <NavLink
                                                        to={ lobby == "SPORTSBOOK" ? `/sb-markets/${btoa(`${game?.id}`)}` :
                                                                `/markets/${btoa(`${game?.id}`)}`}
                                                        className={`nav-link`}
                                                    >
                                                        <div
                                                            className="game-img relative"
                                                            style={{
                                                                marginBottom: "0.5rem",
                                                                height: "6.5rem",
                                                            }}
                                                        >
                                                            <img
                                                                src={game?.thumbnail}
                                                                alt={game?.name}
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    borderRadius: "12px",
                                                                }}
                                                                onError={(e: any) => {
                                                                    e.target.onerror = null; // Prevent infinite loop if fallback fails
                                                                    e.target.src = section.defaultThumbnail;
                                                                }}
                                                            />
                                                            <div style={{ position: 'absolute', top: '5px', right: '5px' }}>
                                                                {game?.isFavorite ? <FavoriteOutlined
                                                                    className="gold-favourite-img"
                                                                    titleAccess={t("casino.removeFromFavourites")}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleFavoriteClick(game);
                                                                    }}
                                                                /> : <FavoriteBorderOutlined
                                                                    className="red-favourite-img"
                                                                    titleAccess={t("casino.addToFavourites")}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleFavoriteClick(game);
                                                                    }}
                                                                />}
                                                            </div>
                                                        </div>
                                                    </NavLink>
                                                    <div className="game-name">{game?.name}</div>
                                                </div>

                                            ))}
                                        </div>
                                    </div>
                                )
                            ))}

                        </div>
                    </>
                )
            }
        </div>
    );
};

export default EventsPage;
